import { SupabaseJob, Job } from '@applicator/shared'
import { useEffect } from 'react'

import { supabase } from '../../../lib/supabase'

import { handleRealtimeUpdate, cleanupChannel } from './realtime'

// Realtime subscription for relevance updates
export function useRealtimeSubscriptionEffect(
  selectedJobId: string | null,
  setSupabaseJobs: React.Dispatch<React.SetStateAction<SupabaseJob[]>>,
  setJobs: React.Dispatch<React.SetStateAction<Job[]>>,
  supabaseJobs: SupabaseJob[]
) {
  useEffect(() => {
    let channel: ReturnType<typeof supabase.channel> | null = null
    let isMounted = true

    const setupSubscription = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser()
        if (!user || !isMounted) return null

        channel = supabase
          .channel('jobs-relevance-updates-detail')
          .on(
            'postgres_changes',
            {
              event: 'UPDATE',
              schema: 'public',
              table: 'jobs',
              filter: `user_id=eq.${user.id}`
            },
            (payload: { new: SupabaseJob; old: SupabaseJob }) => {
              handleRealtimeUpdate(payload, isMounted, selectedJobId, setSupabaseJobs, setJobs, supabaseJobs)
            }
          )
          .subscribe()

        return channel
      } catch (error) {
        console.error('[JOB DETAIL] ❌ Error setting up realtime subscription:', error)
        return null
      }
    }

    const cleanupPromise = setupSubscription()
    
    return () => {
      isMounted = false
      // Use a more defensive cleanup approach
      // Suppress any errors that might occur during cleanup
      cleanupPromise
        .then((ch) => {
          if (ch) {
            cleanupChannel(ch)
          }
        })
        .catch(() => {
          // Silently ignore cleanup errors - they're expected when
          // component unmounts before WebSocket connection is established
        })
    }
  }, [selectedJobId, setSupabaseJobs, setJobs, supabaseJobs])
}
